<template>
    <el-dialog
        :title="(isForm ? (roleId ? '修改字典类型' : '添加字典类型') : '查看') + dialogTitle"
        :close-on-click-modal="false"
        width="640px"
        :model-value="modelValue"
        @close="closed"
    >
        <el-form ref="formRef" :model="formData" :rules="isForm ? formRules : {}" label-width="120px" style="max-width: 540px">
            <el-form-item label="字典名称" prop="name">
                <el-input v-if="isForm" v-model="formData.name"></el-input>
                <span v-else>{{ formData.name }}</span>
            </el-form-item>
            <el-form-item label="字典类型" prop="code">
                <el-input v-if="isForm" v-model="formData.code" v-bind:disabled="formData.id && formData.preset"></el-input>
                <span v-else>{{ formData.code }}</span>
            </el-form-item>
            <el-form-item label="状态">
                <el-radio-group v-if="isForm" v-model="formData.status">
                    <el-radio :value="1">正常</el-radio>
                    <el-radio :value="0">停用</el-radio>
                </el-radio-group>
                <div v-else>{{ formData.status ? '正常' : '停用' }}</div>
            </el-form-item>
            <el-form-item label="备注">
                <el-input v-if="isForm" v-model="formData.remark" type="textarea"></el-input>
                <div v-else>{{ formData.remark }}</div>
            </el-form-item>
            <el-form-item label="所属模块" prop="module" class="selectModule">
                <el-select v-if="isForm" v-model="formData.module" clearable placeholder="数据类型">
                    <el-option
                        v-for="item in modList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        :disabled="!!props.mudule"
                    />
                </el-select>
                <span v-else>{{ formData.module }}</span>
            </el-form-item>
        </el-form>

        <template #footer>
            <span class="dialog-footer">
                <el-button @click="closed">取消</el-button>
                <el-button v-if="isForm" type="primary" :loading="submitLoading" @click="onConfirm">确定</el-button>
            </span>
        </template>
    </el-dialog>
</template>
<script setup>
import { defineEmits, defineProps, onActivated, ref, watch } from 'vue'
import { addDict, getDictDetail, putDict } from '@/api/dict'
import { getAuthTree } from '@/api/auth'
import { ElMessage } from 'element-plus'

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true
    },
    isForm: {
        type: Boolean,
        default: false
    },
    roleId: {
        type: String,
        required: false
    },
    module: {
        type: String,
        required: true
    },
    modList: {
        type: Array,
        default: () => []
    }
})
const dialogTitle = ref('')
const modList = ref([])

const emits = defineEmits(['update:modelValue', 'updateForm'])

// 表单源
const formData = ref({
    name: '',
    code: '',
    list_order: 1,
    status: 1,
    visible: 1,
    remark: '',
    module: props.module,
    preset: ''
})
// 验证规则

const formRules = ref({
    name: [
        {
            required: true,
            trigger: 'blur',
            message: '请输入字典名称'
        }
    ],
    code: [
        {
            required: true,
            trigger: 'blur',
            message: '请输入字典类型'
        }
    ],
    module: [
        {
            required: true,
            trigger: 'blur',
            message: '请输入所属模块'
        }
    ]
})

const submitLoading = ref(false)
const formRef = ref(null)

// 获取所有权限
const allAuthsData = ref([])
const dogetAuthTree = async (filter) => {
    allAuthsData.value = await getAuthTree()
}

// 关闭
const closed = () => {
    emits('update:modelValue', false)
    dialogTitle.value = ''
    formRef.value && formRef.value.resetFields()
}

// 确定按钮点击事件
const onConfirm = async () => {
    if (!props.isForm) return
    if (props.roleId !== '') {
        await doPutDict()
    } else {
        await doAddDict()
    }
}

// 修改模块
const doPutDict = async () => {
    // 进行表单校验
    formRef.value.validate(async (valid) => {
        if (!valid) return
        submitLoading.value = true
        const err = await putDict(formData.value).catch((err) => {
            submitLoading.value = false
            return err
        })
        if (err) return
        // 模块修改成功
        emits('updateForm')
        ElMessage.success('修改成功！')
        submitLoading.value = false
        closed()
    })
}

// 添加模块
const doAddDict = async () => {
    // 进行表单校验
    formRef.value.validate(async (valid) => {
        if (!valid) return
        submitLoading.value = true
        const err = await addDict(formData.value).catch((err) => {
            submitLoading.value = false
            return err
        })
        if (err) return
        // 模块添加成功
        emits('updateForm')
        ElMessage.success('添加成功！')
        submitLoading.value = false
        closed()
    })
}

// 获取字典详情
const doGetDictDetail = async () => {
    const data = await getDictDetail(props.roleId)
    dialogTitle.value = '-' + data.name
    formRef.value.resetFields()
    formData.value = {
        id: data.id,
        name: data.name,
        code: data.code,
        list_order: data.list_order,
        status: data.status,
        visible: data.visible,
        remark: data.remark,
        module: data.module,
        preset: data.preset
    }
}

// 只有roleId有的时候，才会去请求数据
watch(
    () => props.modelValue,
    (newVal) => {
        modList.value = props.modList.map((v) => ({ label: v.name, value: v.id }))

        if (newVal && props.roleId) {
            doGetDictDetail()
        } else {
            formData.value = {
                name: '',
                code: '',
                list_order: 1,
                status: 1,
                visible: 1,
                remark: '',
                module: props.module,
                preset: ''
            }
        }
    }
)

onActivated(() => {
    dogetAuthTree()
})
</script>

<style lang="scss" scoped>
.selectModule {
    display: none;
}
</style>
